import { render } from "./GenealogiaView.vue?vue&type=template&id=03dc05ba&scoped=true"
import script from "./GenealogiaView.vue?vue&type=script&lang=js"
export * from "./GenealogiaView.vue?vue&type=script&lang=js"

import "./GenealogiaView.vue?vue&type=style&index=0&id=03dc05ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dc05ba"]])

export default __exports__